import React from 'react'
import { ItemContainer, ItemLabel } from '../../../../components/styled'
import MaterialSymbol from '../../../../components/MaterialSymbol'
import { Box, useTheme } from '@mui/material'
import { TestIds } from '../../../../testIds'

interface RevertChangesButtonProps {
  onClick?: () => void
}
export const RevertChangesButton: React.FC<RevertChangesButtonProps> = ({ onClick }) => {
  const theme = useTheme()

  // The additional `Box` layer was to prevent the button from spanning
  // the entire width
  return (
    <Box sx={{ display: 'flex' }}>
      <ItemContainer
        wrap
        sx={{
          alignItems: 'center',
          gap: '4px',
          cursor: 'pointer',
        }}
        onClick={onClick}
        data-testid={TestIds.feat.editPrice.revertChanges}
      >
        <MaterialSymbol sx={{ fontSize: 20, padding: '2px', color: theme.colors.primary500 }}>
          Change_Circle
        </MaterialSymbol>
        <ItemLabel
          variant='body2'
          sx={{
            color: theme.colors.primary500,
          }}
        >
          Revert changes
        </ItemLabel>
      </ItemContainer>
    </Box>
  )
}
